import {Injectable, Component} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {SystemUtils} from './systemutils';
import {ISportUtils} from './isport-utils';

@Injectable()
export class AmericanFootballUtils implements ISportUtils {
    private systemUtils: SystemUtils;

    constructor(systemUtils:SystemUtils) {
        this.systemUtils = systemUtils;
    }

    public getPlayingSurfaceDimensions() {
        return {
            xs: { width: 300, height: 138, imageSize: 16 },
            sm: { width: 768, height: 353, imageSize: 16 },
            md: { width: 982, height: 451, imageSize: 16 },
            lg: { width: 982, height: 451, imageSize: 16 }
        };
    }

    public formatPeriodTime(periodTime: number) {
        let minutes:string = Math.floor(periodTime / 60) + "";
        if (minutes.length < 2) {
            minutes = "0" + minutes;
        }

        let seconds:string = (periodTime % 60) + "";
        if (seconds.length < 2) {
            seconds = "0" + seconds;
        }

        return minutes + ":" + seconds;
    }

    public getPeriodLabel(periodNum:number, includeOrdinal:boolean, seasonType:string) {
        let perLabel:string = periodNum + "";

        if (periodNum <= 4) {
            if (includeOrdinal) {
                perLabel += this.systemUtils.getOrdinalSuffix(periodNum);
            }
        } else if (seasonType === "PLAYOFF" && periodNum > 4) {
            perLabel = "OT";
            if (periodNum > 5) {
                perLabel += (periodNum - 4);
            }
        } else if (seasonType === "REGULAR") {
            if (periodNum == 5) {
                perLabel = "OT";
            }
        }

        return perLabel;
    }

    public getOutcomeSuffix(numPeriods: number, seasonType: string) {
        let suffix: string = "";

        if (numPeriods > 4) {
            suffix = " (OT)";
        }

        return suffix;
    }

    public setOutcomeAttributes(gameObj, gameDTO, teamId: number) {
        if (gameDTO.playStatus === "COMPLETED" || gameDTO.playStatus === "UPDATING") {
            if (gameDTO.awayTeamCtx.team.id === teamId) {
                if (gameDTO.awayScore > gameDTO.homeScore) {
                    gameObj._outcome = "W";
                } else if (gameDTO.awayScore === gameDTO.homeScore) {
                    gameObj._outcome = "T";
                } else if (gameDTO.latestPeriodType === "USFTBL_REGULATION") {
                    gameObj._outcome = "L";
                } else {
                    gameObj._outcome = "O";
                }
            } else {
                if (gameDTO.awayScore < gameDTO.homeScore) {
                    gameObj._outcome = "W";
                } else if (gameDTO.awayScore === gameDTO.homeScore) {
                    gameObj._outcome = "T";
                } else if (gameDTO.latestPeriodType === "USFTBL_REGULATION") {
                    gameObj._outcome = "L";
                } else {
                    gameObj._outcome = "O";
                }
            }

            if (gameDTO.latestPeriodType === "USFTBL_OVERTIME") {
                gameObj._isOvertime = true;
            }
        } else if (gameDTO.playStatus == "UNPLAYED") {
            //TODO: determine what to display
        } else if (gameDTO.playStatus == "IN_PROGRESS") {
            //TODO: determine what to display
        }

        return gameObj;
    }

    public resetProfilePlayersForTeam(thisObj:any, teamId:number) {
        if (teamId === thisObj.game.awayTeamCtx.team.id) {
            thisObj.profileAwayPlayers = [];
        } else {
            thisObj.profileHomePlayers = [];
        }
    }

    public populateProfilePlayerForTeam(thisObj: any, gameObj: any, player: any, teamId: number) {
        if (teamId === gameObj.awayTeamCtx.team.id) {
            thisObj.profileAwayPlayers.push(player);
        } else {
            thisObj.profileHomePlayers.push(player);
        }
    }

    public getGameEventTypes() {
        let gameEventTypes: any = {
            typesAndServices: [
                { name: "passingplay", responseAttr: "passingPlays" },
                { name: "lateralpass", responseAttr: "lateralPasses" },
                { name: "rushingplay", responseAttr: "rushingPlays" },
                { name: "sackingplay", responseAttr: "sackingPlays" },
                { name: "kickingplay", responseAttr: "kickingPlays" },
                { name: "kickattempt", responseAttr: "kickAttempts" },
                { name: "penaltyplay", responseAttr: "penaltyPlays" }
            ],

            orderedTypes: ["passingplay",
                "lateralpass",
                "rushingplay",
                "sackingplay",
                "kickingplay",
                "kickattempt",
                "penaltyplay"]
        };

        return gameEventTypes;
    }

    public convertGameEventType(type: string, useCaps: boolean = false) {
        var eventType = "";

        switch (type) {
            case "USFTBL_PASSING_PLAY":
                if (useCaps) {
                    eventType = "PassingPlay";
                } else {
                    eventType = "passingplay";
                }
                break;

            case "USFTBL_LATERAL_PASS":
                if (useCaps) {
                    eventType = "LateralPass";
                } else {
                    eventType = "lateralpass";
                }
                break;

            case "USFTBL_RUSHING_PLAY":
                if (useCaps) {
                    eventType = "RushingPlay";
                } else {
                    eventType = "rushingplay";
                }
                break;

            case "USFTBL_SACKING_PLAY":
                if (useCaps) {
                    eventType = "SackingPlay";
                } else {
                    eventType = "sackingplay";
                }
                break;

            case "USFTBL_KICKING_PLAY":
                if (useCaps) {
                    eventType = "KickingPlay";
                } else {
                    eventType = "kickingplay";
                }
                break;

            case "USFTBL_KICK_ATTEMPT":
                if (useCaps) {
                    eventType = "KickAttempt";
                } else {
                    eventType = "kickattempt";
                }
                break;

            case "USFTBL_PENALTY_PLAY":
                if (useCaps) {
                    eventType = "PenaltyPlay";
                } else {
                    eventType = "penaltyplay";
                }
                break;

            default:
                break;
        }

        return eventType;
    }

}
